import _objectSpread from "D:/svnworkspace/GZEB/webWorks/e-boat-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _createClass from "D:/svnworkspace/GZEB/webWorks/e-boat-web/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "D:/svnworkspace/GZEB/webWorks/e-boat-web/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _defineProperty from "D:/svnworkspace/GZEB/webWorks/e-boat-web/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { render } from "vue";
import { transZhCnElemenComponent } from './utils/elemen-ui-utils';
export var BaseController = /*#__PURE__*/_createClass(
/**
 * 构造搜索表单
 * @param el 挂载节点
 * @param component 组件
 * @param config 属性配置
 */
function BaseController(el, component, config) {
  var _this = this;
  _classCallCheck(this, BaseController);
  /**
   * 组件事件集合
   * @memberof FormDialog
   */
  _defineProperty(this, "handler", new Proxy({}, {}));
  /**
   * 控制器
   * @memberof FormDialog
   */
  _defineProperty(this, "controller", null);
  /**
   * 获取表单实例
   * @param searchFormController 表单实例
   */
  _defineProperty(this, "_getInstance", function (controller) {
    _this.controller = controller;
  });
  render(h(transZhCnElemenComponent(component), _objectSpread({
    getInstance: this._getInstance,
    handler: this.handler
  }, config)), el);
});